import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const BARS = [
    { nm: 'Business Audit', w: '92%', cls: 'blue' },
    { nm: 'Data Repository', w: '78%', cls: 'blue' },
    { nm: 'IP Audit', w: '100%', cls: 'green' },
    { nm: 'AI auto-filled', w: '60%', cls: 'pink' },
];

const CompaniesHeroSection = () => (
    <section className="lp-hero">
        <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
        <div className="lp-hero-inner">
            <div className="lp-hero-copy">
                <div className="lp-badge" data-lp-reveal><span />For Companies</div>
                <h1 className="lp-h1" data-lp-reveal data-lp-delay="60">The pitch gets you the meeting.<br /><span className='lp-h1' style={{ color: '#FC7785' }}>The pack gets you the money.</span></h1>
                <p className="lp-lead" data-lp-reveal data-lp-delay="120">AI-built diligence packs. transaction ready in days. Free to start. Once gold, 1-click connect to investors.</p>
                <div className="lp-cta-row" data-lp-reveal data-lp-delay="180">
                    <Link className="lp-btn lp-btn--primary" to={ROUTES.REGISTER}>Get started free</Link>
                    <a className="lp-btn lp-btn--ghost" href="#lifecycle">See how it works ↓</a>
                </div>
                <div className="lp-hero-social" data-lp-reveal data-lp-delay="240">
                    <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#FC7785', display: 'inline-block', flex: 'none' }} />
                    Less than 1% of unsolicited VC applications succeed · We help you beat the odds
                </div>
            </div>

            <div className="lp-hero-art">
                <div className="lp-hero-stage lp-hero-stage--co">
                    <div className="lp-hero-panel" aria-hidden="true" />
                    <img className="lp-hero-photo" src={require('../../../../images/landing-pages/companies/companies-top-banner.png')} alt="Company CEO" />
                    <div className="lp-hero-pack lp-float" data-lp-reveal data-lp-delay="200">
                        <div className="pk-top">
                            <span className="t">Diligence Pack</span>
                            <span className="g">Gold ✓</span>
                        </div>
                        <div className="pk-chips">
                            <span className="bronze">Bronze ✓</span>
                            <span className="silver">Silver ✓</span>
                            <span className="gold">Gold ✓</span>
                        </div>
                        <div className="pk-bars">
                            {BARS.map((b, i) => (
                                <div className="pk-bar" key={i}>
                                    <span className="nm">{b.nm}</span>
                                    <span className="track"><i className={b.cls} style={{ width: b.w }} /></span>
                                </div>
                            ))}
                        </div>
                        <div className="pk-btn">Share Diligence Pack →</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default CompaniesHeroSection;
